import React from "react";

export default function VersionLabel() {
    return (
        <div style={{ position: 'absolute', top: '0', right: '0', padding: '5px' }}>
            Version 0.1.3
        </div>
    );
}
